import { Link } from "react-router-dom";
import { useTenantPath } from "../../../utils/tenantPath";

type Props = {
  name: string,
  id: string,
  /** Tenant the item was added from. Overrides the current URL's tenant so a
   *  cart item from one shop still links into its own shop, even when viewing
   *  the cart from the other shop's tab. */
  tenant?: string,
}

const CartItemLink = ({ id, name, tenant }: Props) => {
  const path = useTenantPath();

  if (name.endsWith('Shipping')) {
    return (
      <div className='item-link'>{name}</div>
    );
  }

  const to = tenant ? `/r/${tenant}/item/${id}` : path.item(id);

  return (
        <div className='item-link'><Link to={to}>{name}</Link></div>
  )
}

export default CartItemLink
